export async function retryAsyncs(fn, retries = 3 ,delay = 1000) {
    let attempt = 0;
    while(attempt<retries){
        try{
            return await fn();
        }catch(error){
            attempt++;
            console.warn("Intento "+attempt+" Fallido: ",error.message ||error);
            if(attempt < retries){
                await new Promise((resolve) => setTimeout(resolve,delay));
            }else{
                throw error;
            }
        }
    }
}